// components/Footer.js
import React from "react";
import "./Footer.css"; // 如果需要样式的话

function Footer() {
  return (
    <footer
      className="footer"
      style={{
        // backgroundColor: "#fdfaf5", // 强制设置为与 Navbar 相同的颜色
        backgroundColor: "#dbe1e2",
        padding: "2rem 0",
        textAlign: "center",
        color: "#6c757d",
        borderTop: "1px solid #e9ecef",
        marginTop: 0,
      }}
    >
      <div className="container">
        <p>
          &copy; {new Date().getFullYear()} seatedthoughts.com 版权所有。
          <br />
          <a
            href="https://beian.miit.gov.cn/"
            target="_blank"
            // rel="noreferrer"
            rel="noopener noreferrer"
            style={{ color: "#6c757d", textDecoration: "none" }}
          >
            沪ICP备2026006868号-1
            {/* <p> */}
          </a>
          <img src="/head-logo.png" width="20" />{" "}
          <a
            href="https://beian.mps.gov.cn/#/query/webSearch?code=31010702010018"
            rel="noreferrer"
            target="_blank"
            style={{ color: "#6c757d", textDecoration: "none" }}
          >
            沪公网安备31010702010018号
          </a>
          {/* </p> */}
          {/* <a href="https://beian.mps.gov.cn/#/query/webSearch?code=31010702010018" rel="noreferrer" target="_blank">沪公网安备31010702010018号</a> */}
        </p>
      </div>
    </footer>
  );
}

export default Footer;
